import { type ResponseResolver, delay, HttpResponse } from 'msw';
import type { PostSurveyAnswerBody } from '~/api/generated/model';

const statusCode = Number(
  new URLSearchParams(window.location.search).get('statusCode'),
);

export const answer: ResponseResolver<
  Record<string, unknown>,
  PostSurveyAnswerBody
> = async ({ request }) => {
  await delay('real');

  const body = await request.json();

  const mock = (): PostSurveyAnswerBody => {
    return {
      ...body,
    };
  };

  if (!statusCode) {
    return new HttpResponse(JSON.stringify(mock()), { status: 200 });
  }
  return new HttpResponse(
    JSON.stringify({
      type: 'Error',
      path: '/path/to/api',
      message: 'Unauthorized',
    }),
    { status: statusCode },
  );
};
